import { useAppSelector } from "@/redux/store";
import type { Permission } from "@/context/permission";

export const usePermissions = () => {
    const userDetail = useAppSelector((state) => state.user.user);

    const hasPermission = (permission: Permission): boolean => {
        if (!userDetail || !userDetail.role?.permissions) return false;

        const [action, resource] = permission.split(':');

        if (
            userDetail.role.name.toLowerCase() === 'admin' ||
            userDetail.role.permissions.some(
                (p) =>
                    p.resource === '*' ||
                    p.actions.includes('*')
            )
        ) {
            return true;
        }

        const resourcePermission = userDetail.role.permissions.find(
            (p) => p.resource === resource
        );

        return resourcePermission
            ? resourcePermission.actions.includes(action)
            : false;
    };

    return {
        canView: (resource: string) => hasPermission(`view:${resource}` as Permission),
        canCreate: (resource: string) => hasPermission(`add:${resource}` as Permission),
        canEdit: (resource: string) => hasPermission(`update:${resource}` as Permission),
        canDelete: (resource: string) => hasPermission(`delete:${resource}` as Permission),
    };
};
